import { OktaAuth } from '@okta/okta-auth-js'
import { oktaAuthConfig } from 'config'

const oktaAuth = new OktaAuth(oktaAuthConfig)

export default oktaAuth
